import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13679e22&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/魚類販賣系統/shopstore_fish/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13679e22')) {
      api.createRecord('13679e22', component.options)
    } else {
      api.reload('13679e22', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13679e22&", function () {
      api.rerender('13679e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MarkdownEditor/index.vue"
export default component.exports